module.exports = function(app) {
	app.directive('dependentCheckboxValidation', [function() {
		return {

			restrict: 'A',
			require: 'ngModel',

			controller: ['$scope', '$element', function($scope, $element) {
				$scope.$watch('employee.data.globalCoverageEffectiveDate', function(n, o) {
					if (n && n != o) {
						$scope.editCardDependentForm.dependentEditPageCheckbox.$validate();
					}
				});
			}],

			link: function (scope, elem, attrs, ctrl) {
				ctrl.$validators.dependentCheckboxValidation = function (m, v) {
					function truncateToDay(date) {
						date.setHours(0);
						date.setMinutes(0);
						date.setSeconds(0);
						date.setMilliseconds(0);
						return date;
					}
					var lobDate = truncateToDay(new Date(scope.lob.coverageEffectiveDate));
					var changeDate = truncateToDay(new Date(scope.employee.data.globalCoverageEffectiveDate));

					return !v || changeDate >= lobDate;
				};
			}
		};
	}]);
};

